/**
 * A medication course's start or end date, sent from a time editor only when
 * the clinician changed it (PP-OM-03).
 *
 * MedAdmin and CurrentMed's ordered-medication edit stamped `new Date()` on a
 * line with no start and sent it with every time edit. The line's start then
 * moved to the day of the edit (the UTC day — tomorrow from 20:00 in New York),
 * or, once a dose had been charted on an earlier day, every time edit of the
 * line was refused (`medication_start_after_recorded_doses`). A date equal to
 * the line's own, or no date at all, is not a change and is not sent.
 *
 * Both are compared as local calendar days ("YYYY-MM-DD"); a bare day string
 * is taken as it is, because `new Date('2026-10-15')` is UTC midnight, which
 * is the 14th in every US zone.
 *
 * @returns {string} the changed day, or '' when there is nothing to send
 */
export function changedCourseDate(value, original) {
  const next = localDay(value);

  return next !== '' && next !== localDay(original) ? next : '';
}

export function localDay(value) {
  if (value === null || value === undefined || value === '') return '';
  if (typeof value === 'string' && /^\d{4}-\d{2}-\d{2}/.test(value.trim())) return value.trim().slice(0, 10);

  const date = value instanceof Date ? value : new Date(value);

  if (Number.isNaN(date.getTime())) return '';

  const pad = (n) => String(n).padStart(2, '0');

  return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}`;
}
